import {
  FormControl,
  Box,
  Button,
  FormHelperText,
  InputAdornment,
  InputLabel,
  OutlinedInput,
  Stack,
  Grid,
} from "@mui/material";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { SubmitHandler, useForm } from "react-hook-form";
import { OrderInfoForm } from "./types";
import { ChangeEventHandler, useCallback, useEffect, useState } from "react";
import {
  ResourceOperation,
  useApplicationStore,
} from "../../context/ApplicationStoreContext";

const formSchema = yup.object({
  name: yup.string().required("必須です。"),
  amount: yup
    .number()
    .min(10,"ご注文は10個から承ります。")
    .max(10000,"1万個以上のご注文はこのシステムから出来かねます。お手数をおかけしますが、別途ご連絡ください。")
    .typeError("半角数字を入力してください。")
    .required("個数の入力は必須です。"),
  total: yup.number().typeError("半角数字を入力してください。"),
});

const OrderInfo = () => {
  const {
    register,
    formState: { errors },
    setValue,
    getValues,
    trigger,
    handleSubmit,
  } = useForm<OrderInfoForm>({
    resolver: yupResolver(formSchema),
    defaultValues: {
      amount: 10,
      total: 2200,
    },
  });
  const [price, setPrice] = useState<number>(220);

  const priceStepper = (
    value: string
  ) => {
    const _amount = parseInt(value) || 10
    setValue("amount",_amount)
    if (_amount < 50) {
      setPrice(220);
      setValue("total",220*_amount);
    } else if (_amount < 100) {
      setPrice(200);
      setValue("total",200*_amount);
    } else if (_amount < 1000) {
      setPrice(180);
      setValue("total",180*_amount);
    } else {
      setPrice(150);
      setValue("total",150*_amount);
    }
  };

  const { state, dispatch } = useApplicationStore();

  const onSubmit: SubmitHandler<OrderInfoForm> = (data) => {
    dispatch({
      type: ResourceOperation.VALIDATED_ORDER_INFO_FORM,
      payload: data,
    });
    dispatch({ type: ResourceOperation.ADD_INDEX });
  };


  useEffect(()=>{
    if(state.orderInfoForm!==null){
      setValue("name",state.orderInfoForm.name)
      setValue("amount", state.orderInfoForm.amount)
      setValue("total",state.orderInfoForm.total)
    }else{
      setValue("name", "ノベルティクッキー");
      setValue("amount", 10)
      setValue("total",2200)
    }
  },[state.orderInfoForm])

  return (
    <>
      <Stack spacing={2}>
        <Box>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <FormControl>
                <InputLabel htmlFor="outlined-amount">個数</InputLabel>
                <OutlinedInput
                  id="outlined-amount"
                  type="number"
                  label="個数"
                  defaultValue={getValues("amount")}
                  required
                  onInput={(e)=>{
                    //@ts-ignore
                    setValue("amount", parseInt(e.target.value))
                    trigger("amount")
                  }}
                  onChange={(e)=>{
                    setValue("amount", parseInt(e.target.value))
                    priceStepper(e.target.value)
                    trigger("amount")
                  }}
                  error={"amount" in errors}
                  endAdornment={
                    <InputAdornment position="end">個</InputAdornment>
                  }
                />
                <FormHelperText className="MuiFormHelperText-root Mui-error">
                  {errors.amount?.message}
                </FormHelperText>
              </FormControl>
            </Grid>
            <Grid item xs={6}>
              <FormControl>
                <InputLabel htmlFor="outlined-price">単価</InputLabel>
                <OutlinedInput
                  id="outlined-price"
                  label="単価"
                  disabled
                  value={price}
                  startAdornment={
                    <InputAdornment position="start">¥</InputAdornment>
                  }
                />
              </FormControl>
            </Grid>
          </Grid>
        </Box>
        <Box>
          <FormControl sx={{ mt: 1 }}>
            <InputLabel htmlFor="outlined-total">金額</InputLabel>
            <OutlinedInput
              id="outlined-total"
              label="金額"
              disabled
              required
              {...register("total")}
              error={"total" in errors}
              startAdornment={
                <InputAdornment position="start">¥</InputAdornment>
              }
            />
            <FormHelperText className="MuiFormHelperText-root Mui-error">
              {errors.total?.message}
            </FormHelperText>
          </FormControl>
        </Box>
        <Box sx={{ mb: 2 }}>
          <div>
            <Button
              variant="contained"
              onClick={handleSubmit(onSubmit)}
              sx={{ mt: 1, mr: 1 }}
            >
              次へ
            </Button>
            <Button
              onClick={() => dispatch({ type: ResourceOperation.SUB_INDEX })}
              sx={{ mt: 1, mr: 1 }}
            >
              戻る
            </Button>
          </div>
        </Box>
      </Stack>
    </>
  );
};

export default OrderInfo;
